define('modules/common/service/Analytics',[], function() {
    var Analytics = function($rootScope, $window, $location) {

        return {
            track: function() {
                $window._gaq.push(['_trackPageview', $location.path()]);
            },
            setCustomVar: function(index, name, value, scope) {
                $window._gaq.push(['_setCustomVar', index, name, value, scope]);
            },
            trackEvent: function(category, action, label, value) {
                //console.log("LOG:"+category+'.'+action+'.'+label+'.'+value);
                $window._gaq.push(['_trackEvent', category, action, label, value]);
            }
        };

    };
    return ["$rootScope", "$window", "$location", Analytics];
});
